import {React} from 'common'
import {Box, TableRow} from '@mui/material'
import RawTableHead from '@mui/material/TableHead'
import {useTranslation} from 'react-i18next'
import TableSort from './TableSort'
import TableCell from './TableCell'

const TableHead = ({itemName, tableKeys, allowExpanded, allowEdit, allowDelete}) => {
    const {t} = useTranslation()
    const isActionCell = allowExpanded || allowEdit || allowDelete
    return (
        <RawTableHead>
            <TableRow>
                {tableKeys.map((key) => (
                    <TableCell key={`head_${key?.key ?? key}`} align="center">
                        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <TableSort key={key} itemKey={key} itemName={itemName}>
                                {t(`${itemName}s.${key?.key ?? key}`)}
                            </TableSort>
                        </Box>
                    </TableCell>
                ))}
                {isActionCell && <TableCell></TableCell>}
            </TableRow>
        </RawTableHead>
    )
}

export default TableHead
